import _ from 'lodash';

import api from './api';

export default {
  // Fetch global or clinic config (if clinicId specified)
  show(clinicId = null) {
    let url = '/config/';
    if (clinicId) {
      url = `${url}${clinicId}`;
    }
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`List Error: ${response}, url: ${url}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  // NOTE: Currently membership is only in the global config so we don't need to use clinicId
  getMembershipConfig() {
    const url = '/config/membership';
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`List Error: ${response}, url: ${url}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  categoryIsUsed(category) {
    const url = `/config/appointment/category/${category}/used`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`List Error: ${response}, url: ${url}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  dragoncareCategoryIsUsed(category) {
    const url = `/config/appointment/dc-category/${category}/used`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`List Error: ${response}, url: ${url}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  providerClassIsUsed(klass) {
    const url = `/config/provider/category/${klass}/used`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`List Error: ${response}, url: ${url}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  // Upsert global or clinic config (if clinicId specified)
  upsert(payload, clinicId = null) {
    let url = '/config/';
    if (clinicId) {
      url = `${url}${clinicId}`;
    }

    return new Promise((resolve, reject) => {
      api.post(url, payload).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({
              data, message: '', success: true, error: null,
            });
          } else if (response.status === 409 && !!_.find(response.body.errors, ['errorCode', 'ConflictClinicCode'])) {
            reject(new Error('ConflictClinicCode'));
          } else {
            const errors = response.body.errors?.map(e => e.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  async hubspotIsValid(accessToken = "") {
    let url = '/config/hubspot/check';
    const payload = { accessToken: accessToken }
    return new Promise((resolve, reject) => {
      api.post(url, payload).then(
        (response) => {
          const output = response.ok && response?.body?.pass
          resolve(output);
        },
        (error) => {
          resolve(output)
        },
      );
    });
  },

  // TODO: calculate what provider are using this category.
  async providerCategoryIsUsed(/* category */) {
    return {
      data: [],
      message: '',
      success: true,
    };
  },

  fetchNegInvStock() {
    const url = '/config/inventory/negInvStock';
    return new Promise((resolve, reject) => {
      api.get(url)
        .then((response) => {
          if (response.ok) {
            const data = response.body.availableQuantity;
            const negInvData = _.find(data, (x) => {
              if (x.qty < 0) { return (x); }
            });
            resolve({
              negInvData, message: '', success: true, error: null,
            });
          }
          reject(
            new Error(`List Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        });
    });
  },
};
